import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';
import Movie from './Movie.js';

class App extends Component {
	// Render: componentWillMount() -> render() -> componentDidMount()
	// Update: componentWillReceiveProps() -> shouldComponentUpdate() -> componentWillUpldate() -> render () -> componentDidUpdate()

	state = {}

	componentDidMount() {	// 성공적으로 리액트에 컴포넌트가 자리잡음
		this._getMovies();
	}

	_renderMovies = () => {	// _로 시작하는 건 리액트에 많은 기능이 있어 나의 기능은 _(언더스코어)로 시작하게 하려는 것임
		//console.log(movies)
		const movies = this.state.movies.map((movie) => {
			return <Movie 
				title={movie.title_long} 
				poster={movie.medium_cover_image} 
				key={movie.id} 
				genres={movie.genres} 
				synopsis={movie.synopsis}
			/>
		})
		return movies
	}

	_getMovies = async () => {
		const movies = await this._callApi()  
		// await를 사용하는 것은 _callApi 기능이 끝나는 것을 기다리게 하기 위해서 (성공여부x)

		console.log(movies)
		this.setState({ // _callApi가 끝나면 실행
			movies
		})
	}
	_callApi = () => {
		return fetch('https://yts.am/api/v2/list_movies.json?sort_by=download_count') // url 불러오기

		.then(	// 위의 작업이 끝나면 실행 (성공여부 X)
			response => response.json()	// response로 체크하고, json으로 변환 
		)
		.then(json => //{console.log(json)}
			json.data.movies
		)
		.catch(err => console.log(err))	// 위에 라인들이 완료가 되면 뭔가를 해라, 에러가 나면 잡아서 설명해줘
	}


	render() {	// 리액트 존재
		const {movies} = this.state;
		return (
			<div className={movies ? "App" : "App--loading"}> 
				{	// movies가 있으면 div의 클래스 명은 App, 없으면 App--loading
					this.state.movies ? this._renderMovies() : 'Loding.... 크롬으로 확인하시길 권장합니다.'
					// 만약 this.state.movies가 true면 this._renderMovies() 출력, falset면 Loding 출력 (setTimeout 때문에 2초 전엔 거짓, 2초 후엔 참)
				}

			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js